// extracted by mini-css-extract-plugin
export default {"Box":"row-reorder-sash-module__Box--nTSiN","Octicon":"row-reorder-sash-module__Octicon--lahUg"};